/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientListOptionAction } from "../../../../services/action/manager";
import CountryDropdown from "../../../utils/country-dropdown/CountryDropdown";
import debounce from "lodash/debounce";
import NewSelectBox from "../../../utils/select/NewSelectBox";
import { courses, universities } from "../../../constants/commonConstant";

const BasicClientDetail = ({ data, register, getWatch, errors, setValue }) => {
  const { clientOption } = useSelector((state) => state.managerReducer);
  const { user } = useSelector((state) => state.authenticationReducer);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [localOptions, setLocalOptions] = useState([]);

  const userType = user?.userType?.toLowerCase();
  const isManager = userType === "manager";
  const isAdminOrSuperAdmin = ["admin", "super_admin"].includes(userType);
  const isOperator = userType === "operator";
  const isClient = userType === "client";

  useEffect(() => {
    if (isClient) {
      setValue("email", user?.email);
      setValue("name", user?.name);
      setValue("number", user?.number);
      setValue("countryCode", user?.countryCode);
    }
  }, [user, setValue, isClient]);

  useEffect(() => {
    if (!isClient) {
      dispatch(getClientListOptionAction({ userType }));
    }
  }, [userType, dispatch, isClient]);

  useEffect(() => {
    if (clientOption?.data) {
      const formattedOptions = clientOption.data.map((item) => ({
        label: item.name ? `${item.name} (${item.email})` : item.email,
        value: item.value || item.email,
        ...item,
      }));
      console.log("Setting formatted options:", formattedOptions);
      setLocalOptions(formattedOptions);
    }
  }, [clientOption]);

  const selectedClient = useMemo(() => {
    return localOptions.find((item) => item.value === getWatch?.client);
  }, [localOptions, getWatch?.client]);

  const handleClientSelect = (selectedOption) => {
    if (selectedOption) {
      setValue("countryCode", selectedOption.countryCode);
      setValue("client", selectedOption.value);
      setValue("number", selectedOption.number);
      setValue("email", selectedOption.email);
      setValue("name", selectedOption.name);
      // setValue("university", selectedOption.university);
      // setValue("course", selectedOption.course);
      setValue("year", selectedOption.year);

      if (selectedOption?.course) {
        const courseOption = courses
          .flatMap((group) => group.options)
          .find((option) => option.value === selectedOption.course);
        setValue("course", courseOption);
      }

      if (selectedOption?.university) {
        const universityOption = universities
          .flatMap((group) => group.options)
          .find((option) => option.value === selectedOption.university);
        setValue("university", universityOption);
      }
    }
  };

  const isFieldDisabled = (isAdmin = false) => {
    return (data || isClient );
  };

  const debouncedSearch = useCallback(
    debounce((searchText) => {
      if (typeof searchText === "string") {
        setIsLoading(true);
        dispatch(
          getClientListOptionAction({
            userType,
            data: { email: searchText.trim() || "" },
          })
        );
        setTimeout(() => setIsLoading(false), 500);
      }
    }, 300),
    []
  );

  const handleClientSearch = (searchText) => {
    setSearchTerm(searchText);
    debouncedSearch(searchText);
  };

  // Remove the email pattern and use a custom validation function
  const validateEmail = (email) => {
    // Basic email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // const numberPattern = /^\d{3}\*{3}\d{3}$/;

  const formatNumber = (value) => {
    const digits = value.replace(/[^0-9]/g, "");
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}***${digits.slice(3)}`;
    return `${digits.slice(0, 3)}***${digits.slice(-3)}`;
  };

  const handleNumberChange = (e) => {
    let formattedNumber = e.target.value;
    // if(selectedClient?._id){

    // }
    
    // formatNumber(e.target.value);
    setValue("number", formattedNumber);
  };

  return (
    <div className="col-12">
      <div className="row">
        {(isManager || isClient || !data || isAdminOrSuperAdmin) && (
          <Fragment>
            {!isClient && (
              <div className="col-sm-6">
                <label
                  className={`form-label ${
                    errors?.client ? "text-danger" : ""
                  }`}
                >
                  Select Client<span className="text-danger">*</span>
                </label>
                <input
                  type="hidden"
                  {...register("client", { required: true })}
                />
                <NewSelectBox
                  options={localOptions}
                  value={selectedClient}
                  onChange={handleClientSelect}
                  onInputChange={handleClientSearch}
                  placeholder="Search by email..."
                  noOptionsMessage={() => "No clients found"}
                  loadingMessage={() => "Searching..."}
                  isLoading={isLoading}
                  disabled={isFieldDisabled()}
                  creatable={true}
                />
              </div>
            )}

            {isClient && (
              <div className="col-sm-6">
                <label
                  className={`form-label ${errors?.email ? "text-danger" : ""}`}
                >
                  Email<span className="text-danger">*</span>
                </label>
                <input
                  {...register("email", {
                    required: !data,
                    validate: validateEmail,
                  })}
                  type="email"
                  disabled={true}
                  className="form-control"
                />
              </div>
            )}

            <div className="col-sm-6">
              <label
                className={`form-label ${errors?.number ? "text-danger" : ""}`}
              >
                Contact No <span className="text-danger">*</span>
              </label>
              <CountryDropdown
                value={getWatch?.countryCode}
                disabled={isFieldDisabled() || selectedClient?._id}
                onChange={(e) => setValue("countryCode", e?.countryCode)}
              />
              <input
                {...register("number", {
                  required: !data,
                  // pattern: numberPattern,
                  onChange: handleNumberChange,
                })}

                type="text"
                disabled={isFieldDisabled() || selectedClient?._id}
                style={{
                  paddingLeft: getWatch?.countryCode?.length > 3 ? 59 : 40,
                }}
                className="form-control"
              />
            </div>
          </Fragment>
        )}

        <div className="col-sm-6">
          <label className={`form-label ${errors?.name ? "text-danger" : ""}`}>
            Name<span className="text-danger">*</span>
          </label>
          <input
            {...register("name", { required: true })}
            type="text"
            disabled={isFieldDisabled()}
            className="form-control"
          />
        </div>

        <div className="col-sm-6">
          <label
            className={`form-label ${errors?.category ? "text-danger" : ""}`}
          >
            Category<span className="text-danger">*</span>
          </label>
          <select
            className="form-control"
            {...register("category", { required: true })}
            disabled={!isManager && !isOperator && !isAdminOrSuperAdmin && data}
          >
            <option value="">Select Category</option>
            <option value="Assignment">Assignment</option>
            <option value="SOP">SOP</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default BasicClientDetail;
